import {
  Action,
  ActionType,
  IApproveAbsenceResponse,
} from "models/bodyTemperature/approveAbsence";
import createReducer from "../../createReducer";

export interface ApproveAbsenceReducerType {
  loading: boolean;
  error?: string;
  approveAbsenceResponse?: IApproveAbsenceResponse;
}

const defaultState: ApproveAbsenceReducerType = {
  loading: false,
  error: undefined,
  approveAbsenceResponse: undefined,
};

export const approveAbsenceReducer = createReducer<ApproveAbsenceReducerType>(
  defaultState,
  {
    [ActionType.APPROVE_ABSENCE](state: ApproveAbsenceReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.APPROVE_ABSENCE_ERROR](
      state: ApproveAbsenceReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
        approveAbsenceResponse: undefined,
      };
    },

    [ActionType.APPROVE_ABSENCE_SUCCESS](
      state: ApproveAbsenceReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        approveAbsenceResponse: action.payload,
      };
    },

    [ActionType.APPROVE_ABSENCE_RESET](state: ApproveAbsenceReducerType) {
      return {
        ...state,
        loading: false,
        error: null,
        approveAbsenceResponse: undefined,
      };
    },
  }
);
